
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/influencer",
      function () {
        return require("private-next-pages/influencer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/influencer"])
      });
    }
  